// Miscellaneous Imports
import 'whatwg-fetch'
import { CookiesProvider } from 'react-cookie'
import debug from 'debug'
import { createBrowserHistory } from 'history'

// React Imports
import React from 'react'
import ReactDOM from 'react-dom'
// import axe from 'react-axe'

import { loadableReady } from '@loadable/component'

// Redux imports
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import reportPdpABTest from './utils/reportPdpABTest'
import configureStore from './stores/ReduxStore'

import { handleAnalyticsSetUp } from './helpers/taggingSerializer'

import { getClientSideYourekoEnabledFlag, enableGlobalYourekoTracking } from './helpers/youRekoHelper'
import { YourekoProvider } from './providers/Youreko/YourekoContext'
import { AddToTrolleyProvider } from './providers/AddToTrolleyContext/AddToTrolleyContext'

// Application Imports
import App from './components/Application'
import './components/main.scss'
import rootSaga from './sagas/root.saga'

const appDebug = debug('App')

const BRAND = process.env.BRAND || 'ARGOS'

const isProduction = process.env.NODE_ENV === 'production'
if (isProduction) {
  debug.disable()
} else {
  debug.enable('App, Analytics, BazaarVoiceAction, ArgosProductPurchaseJSON, SpecialOffersAction, Recommendations:*')
}

// if (process.env.NODE_ENV !== 'production') {
//   axe(React, ReactDOM, 1000)
// }

// Add to temporarily remove service workers for Safari 17 and above
const isSafari17andAbove = () => {
  const ua = navigator.userAgent
  const isSafari = ua.indexOf('Safari') !== -1
  const version = ua.substring(ua.indexOf('Version/') + 8)
  const majorVersion = parseInt(version, 10)

  return isSafari && majorVersion >= 17
}

// Register Service Worker
if (BRAND === 'ARGOS' && 'serviceWorker' in navigator && !isSafari17andAbove()) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', {
        scope: '/'
      })
      .then(registration => {
        console.log('SW registered: ', registration) // eslint-disable-line no-console
      })
      .catch(registrationError => {
        console.log('SW registration failed: ', registrationError) // eslint-disable-line no-console
      })
  })
}

handleAnalyticsSetUp()

let browserHistory
try {
  browserHistory = createBrowserHistory()
} catch (error) {
  console.error('Error creating browser history', error)
  browserHistory = {
    listen: () => {},
    push: () => {},
    replace: () => {},
    go: () => {},
    goBack: () => {},
    goForward: () => {},
    block: () => {},
    createHref: () => {},
    location: {},
    action: 'POP'
  }
}
const allowReduxTools = !isProduction
const store = configureStore(
  browserHistory,
  {
    productStore: window.__data.productStore,
    bazaarVoiceQuestionAnswer: window.__data.bazaarVoiceQuestionAnswer,
    bazaarVoiceReview: window.__data.bazaarVoiceReview,
    specialOffersCreator: window.__data.specialOffersCreator,
    cms: window.__data.cms
  },
  allowReduxTools
)

const isYourekoEnabled = getClientSideYourekoEnabledFlag()
if (isYourekoEnabled) {
  enableGlobalYourekoTracking()
}

store.runSaga(rootSaga)

loadableReady(() => {
  ReactDOM.hydrate(
    <Provider store={store}>
      <CookiesProvider>
        <YourekoProvider isYourekoEnabled={isYourekoEnabled}>
          <AddToTrolleyProvider>
            <ConnectedRouter history={browserHistory}>
              <App />
            </ConnectedRouter>
          </AddToTrolleyProvider>
        </YourekoProvider>
      </CookiesProvider>
    </Provider>,
    document.getElementById('app'),
    () => {
      appDebug('React Rendered')
      reportPdpABTest()
    }
  )
})
